import getArrayHash from './getArrayHash';

function getNodeKey(node) {
    return `${node.id}-${node.request}-${getArrayHash(node.response, ['text'])}-${JSON.stringify(node.visualProperties?.expectedResponses)}-${node.visualProperties?.condition}-${JSON.stringify(node.meta)}`;
}



export default getNodeKey;
